//Backend URL:

/**Local */
// export const BASE_URL = "http://localhost:3200";
// export const REACT_APP_URL = "http://localhost:3001";
// export const CDN_CONTAINER = "devuploads"

/**Dev */
export const BASE_URL = "https://dev-api.skortorent.com";
export const REACT_APP_URL = "https://dev.skortorent.com";
export const CDN_CONTAINER = "devuploads"

/**Live */
// export const BASE_URL = "https://api.skortorent.com";
// export const REACT_APP_URL = "https://app.skortorent.com";
// export const CDN_CONTAINER = "uploads"

//Stagging
//export const BASE_URL = "https://uno.dev.seraphic.io/api";
// export const BASE_URL = "https://api.unorenting.com"

//Live
// export const BASE_URL = "http://54.164.159.66:4000";
// export const BASE_URL = "https://api.dygres.com";

export const CDN_ENDPOINT = "https://skorcdn.blob.core.windows.net"
export const SKOR_MODAL_PROXY_API = `${BASE_URL}/admin/orchestrator/analyze`
